export default [
    {
      path: '/admin/agency/drops',
      name: 'drop-package',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/drop-package/index.vue')
    }
  ]
